// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup-details-planning label {
  font-size: 12px;
  font-weight: bold;
  margin: 8px 0;
}
.popup-details-planning label .active-taskname {
  color: #003da5;
  padding-left: 5px;
}
.popup-details-planning .p-dialog-content {
  overflow-y: none !important;
}
.popup-details-planning .tasksname {
  display: block !important;
}
.popup-details-planning .tasksname ul {
  list-style: none;
  padding: 0 0px !important;
  max-height: 130px !important;
  overflow-y: auto;
  width: 95%;
  margin-bottom: 20px;
}
.popup-details-planning .tasksname ul li {
  padding: 5px 0;
}
.popup-details-planning .acp-dialog .p-dialog-content {
  padding: 0 0 0 0 !important;
  overflow-y: hidden !important;
}
.popup-details-planning .booking-dialog-acp {
  font-weight: 900;
  font-size: 18px !important;
  text-align: left;
  color: #003da5 !important;
}
.popup-details-planning .p-autocomplete {
  width: 200px;
  border: 1px solid #acacac;
  border-radius: 4px;
}
.popup-details-planning .help-user {
  margin-top: 10px;
}
.popup-details-planning .p-inputtextarea {
  width: 100%;
  border-radius: 14px;
  height: 200px;
  margin: 10px 0;
  border: 1px solid #acacac;
}
.popup-details-planning .p-button-icon {
  color: #adadad;
}

#delegate-submit,
#help-submit {
  padding: 0 !important;
  display: flex;
}

#delegate-submit {
  justify-content: flex-end;
}

#help-submit {
  justify-content: space-between;
}

.comments-validation {
  font-size: 12px;
  padding: 0;
}

.p-dialog .p-dialog-header {
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
}

.popup-details {
  padding-top: 20px !important;
}

.row-fields {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
}

.p-dialog .p-dialog-header .p-dialog-header-icon:enabled:hover {
  color: #343a40;
  border-color: transparent !important;
  background: transparent !important;
  box-shadow: none !important;
}

.acp-select-box {
  width: 100%;
  margin-bottom: 30px;
}

.acp-calender {
  width: 100%;
}
.acp-calender .p-button {
  background: #ffffff !important;
}

.select-drop {
  width: 100%;
  height: 32px;
}

.select-drop-down {
  margin: 0;
  padding: 10px 5px;
  border: 0 none;
  color: #495057;
  background: transparent;
  transition: box-shadow 0.2s;
  border-radius: 0;
  font-size: 14px;
}

.warning-text {
  color: #a50b00;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/components/ACP/common/Dialog/AcpPlanningDialog.scss"],"names":[],"mappings":"AACE;EACE,eAAA;EACA,iBAAA;EACA,aAAA;AAAJ;AAEI;EACE,cAAA;EACA,iBAAA;AAAN;AAIE;EACE,2BAAA;AAFJ;AAKE;EACE,yBAAA;AAHJ;AAKI;EACE,gBAAA;EACA,yBAAA;EACA,4BAAA;EACA,gBAAA;EACA,UAAA;EACA,mBAAA;AAHN;AAKM;EACE,cAAA;AAHR;AAQE;EACE,2BAAA;EACA,6BAAA;AANJ;AASE;EACE,gBAAA;EACA,0BAAA;EACA,gBAAA;EACA,yBAAA;AAPJ;AAWE;EACE,YAAA;EACA,yBAAA;EACA,kBAAA;AATJ;AAYE;EACE,gBAAA;AAVJ;AAaE;EACE,WAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,yBAAA;AAXJ;AAcE;EACE,cAAA;AAZJ;;AAgBA;;EAEE,qBAAA;EACA,aAAA;AAbF;;AAgBA;EACE,yBAAA;AAbF;;AAgBA;EACE,8BAAA;AAbF;;AAgBA;EACE,eAAA;EACA,UAAA;AAbF;;AAgBA;EACE,6BAAA;EACA,4BAAA;AAbF;;AAgBA;EACE,4BAAA;AAbF;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;AAbF;;AAgBA;EACE,cAAA;EACA,oCAAA;EACA,kCAAA;EACA,2BAAA;AAbF;;AAgBA;EACE,WAAA;EACA,mBAAA;AAbF;;AAgBA;EACE,WAAA;AAbF;AAeE;EACE,8BAAA;AAbJ;;AAiBA;EACE,WAAA;EACA,YAAA;AAdF;;AAoBA;EACE,SAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;EACA,uBAAA;EACA,2BAAA;EACA,gBAAA;EACA,eAAA;AAjBF;;AAmBA;EACE,cAAA;EACA,gBAAA;AAhBF","sourcesContent":[".popup-details-planning {\n  label {\n    font-size: 12px;\n    font-weight: bold;\n    margin: 8px 0;\n\n    .active-taskname {\n      color: #003da5;\n      padding-left: 5px;\n    }\n  }\n\n  .p-dialog-content {\n    overflow-y: none !important;\n  }\n\n  .tasksname {\n    display: block !important;\n\n    ul {\n      list-style: none;\n      padding: 0 0px !important;\n      max-height: 130px !important;\n      overflow-y: auto;\n      width: 95%;\n      margin-bottom: 20px;\n\n      li {\n        padding: 5px 0;\n      }\n    }\n  }\n\n  .acp-dialog .p-dialog-content {\n    padding: 0 0 0 0 !important;\n    overflow-y: hidden !important;\n  }\n\n  .booking-dialog-acp {\n    font-weight: 900;\n    font-size: 18px !important;\n    text-align: left;\n    color: #003da5 !important;\n  }\n\n\n  .p-autocomplete {\n    width: 200px;\n    border: 1px solid #acacac;\n    border-radius: 4px;\n  }\n\n  .help-user {\n    margin-top: 10px;\n  }\n\n  .p-inputtextarea {\n    width: 100%;\n    border-radius: 14px;\n    height: 200px;\n    margin: 10px 0;\n    border: 1px solid #acacac;\n  }\n\n  .p-button-icon {\n    color: #adadad;\n  }\n}\n\n#delegate-submit,\n#help-submit {\n  padding: 0 !important;\n  display: flex;\n}\n\n#delegate-submit {\n  justify-content: flex-end;\n}\n\n#help-submit {\n  justify-content: space-between;\n}\n\n.comments-validation {\n  font-size: 12px;\n  padding: 0;\n}\n\n.p-dialog .p-dialog-header {\n  border-top-right-radius: 20px;\n  border-top-left-radius: 20px;\n}\n\n.popup-details {\n  padding-top: 20px !important;\n}\n\n.row-fields {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.p-dialog .p-dialog-header .p-dialog-header-icon:enabled:hover {\n  color: #343a40;\n  border-color: transparent !important;\n  background: transparent !important;\n  box-shadow: none !important;\n}\n\n.acp-select-box {\n  width: 100%;\n  margin-bottom: 30px;\n}\n\n.acp-calender {\n  width: 100%;\n\n  .p-button {\n    background: #ffffff !important;\n  }\n}\n\n.select-drop {\n  width: 100%;\n  height: 32px;\n  // :hover{\n  //   background: #adadad !important;\n  // }\n}\n\n.select-drop-down {\n  margin: 0;\n  padding: 10px 5px;\n  border: 0 none;\n  color: #495057;\n  background: transparent;\n  transition: box-shadow 0.2s;\n  border-radius: 0;\n  font-size: 14px;\n}\n.warning-text{\n  color: #a50b00;\n  font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
